import EntityAttackPathBaseNode from './EntityAttackPathBaseNode'
import type EntityAttackPathNode from './EntityAttackPathNode'

export default class EntityAttackPathNodeDrawer extends EntityAttackPathBaseNode {
  // Coordinates of the node before being moved after an expansion
  baseX = 0
  baseY = 0

  isExpanded = false

  constructor(data: Partial<EntityAttackPathNode>) {
    super()
    Object.assign(this, data)
  }
}
